export default {
    Default: {
    },

    language() {
        let lang = window.navigator.languages ? window.navigator.languages[0] : null;
        lang = lang || window.navigator.language;

        let shortLang = lang;
        if (shortLang.indexOf('-') !== -1)
            shortLang = shortLang.split('-')[0];

        if (shortLang.indexOf('_') !== -1)
            shortLang = shortLang.split('_')[0];

        return shortLang.toUpperCase();
    },

    popup (component, resource, parameter, action) {
        component.$bus.$emit(component.$events.message, {
            id       : resource,
            parameter: parameter,
            action   : action,
        });
    },

    confirm (component, query, text, parameter, callback) {
        component.$bus.$emit(component.$events.alert.confirm, {
            query   : query,
            text    : text,
            spinner : parameter.spinner ? parameter.spinner : false,
            width   : parameter.width   ? parameter.width   : null,
            callback: callback
        });
    },

    hint (component, message, close) {
        component.$bus.$emit(component.$events.alert.message, { close: close, message: message });
    },

    error (component, message, close) {
        component.$bus.$emit(component.$events.alert.error, { close: close, message: message });
    },

    warning (component, message, close) {
        component.$bus.$emit(component.$events.alert.warning, { close: close, message: message });
    },

    alert: {
        save (component) {
            component.$bus.$emit(component.$events.alert.message, { close: false, message: component.$t("common.stored") });
        }
    },
}